<template>
    <v-fab
        app
        icon
        color="primary"
        size="large"
        rounded="xxl"
        location="bottom right"
        :color="menu ? 'grey darken-1' : 'primary'"
    >
        <v-icon>mdi-earth</v-icon>

        <v-speed-dial
            v-model="menu"
            transition="slide-y-reverse-transition"
            location="bottom right"
            activator="parent"
        >
            <v-btn
                v-for="(flagFile, code) in languages"
                :key="code"
                @click="changeLanguage(code)"
                class="flag-btn"
                rounded="xxl"
                variant="text"
                color="transparent"
                elevation="0"
            >
                <v-img :src="getFlag(flagFile)" class="flag-icon" cover />
            </v-btn>
        </v-speed-dial>
    </v-fab>
</template>

<script>
import emitter from "@/eventBus";
import axios from "axios";

export default {
    name: "LanguageSelector",

    data() {
        return {
            menu: false, // Controls the speed-dial menu visibility
            languages: {
                en: "Flag-Great Britain.svg",
                ro: "Flag-Romania.svg",
                de: "Flag-Germany.svg",
                hu: "Flag-Hungary.svg",
                fr: "Flag-France.svg"
            },
        };
    },

    mounted() {
        this.setDefaultLanguage();
    },

    methods: {
        /**
         * Dynamically generates the correct path for flag images in assets.
         * @param {string} fileName - The SVG file name (e.g., 'Germany.svg').
         * @returns {string} - The resolved image path.
         */
        getFlag(fileName) {
            return `/country-flags/${fileName}`; // Serves from `public/`
        },

        /**
         * Changes the current application language
         * @param {string} lang - Language code (e.g., 'en', 'ro')
         */
        changeLanguage(lang) {
            this.$i18n.locale = lang;
            // Also inform the backend (Accept-Language or cookie approach).
            axios.defaults.headers.common['Accept-Language'] = lang;
            this.menu = false;
            emitter.emit("language-changed", lang); // Notify other components
            localStorage.setItem("selectedLanguage", lang); // Persist user choice
        },

        /**
         * Detects the user's preferred browser language and sets it if no language is chosen.
         */
        setDefaultLanguage() {
            const savedLang = localStorage.getItem("selectedLanguage");
            if (savedLang && this.languages[savedLang]) {
                this.$i18n.locale = savedLang;
                return;
            }

            const browserLang = navigator.language.split("-")[0]; // Extract "en" from "en-US"
            const defaultLang = this.languages[browserLang]
                ? browserLang
                : "en"; // Fallback to English

            this.changeLanguage(defaultLang);
        },
    },
};
</script>
